import config from '../../config';
import { getHostedDashboardServiceHost, isLocalLikeHost } from '../../utils/environmentMode';

const PRODUCTION_DASHBOARD_HOST = 'dashboard.gophr.app';
const PRODUCTION_SHIPMENTS_HOST = 'https://api-shipments.gophr.app';
const DEVELOPMENT_SHIPMENTS_HOST = 'https://dev-api-shipments.gophr.app';

const isProductionDashboardBrowser = () =>
	typeof window !== 'undefined' &&
	window.location &&
	typeof window.location.hostname === 'string' &&
	(window.location.hostname === PRODUCTION_DASHBOARD_HOST || window.location.hostname.endsWith(`.${PRODUCTION_DASHBOARD_HOST}`));

const resolveProductionBrowserHost = (configuredHost, productionHost) => {
	if (!isProductionDashboardBrowser()) {
		return configuredHost;
	}

	if (typeof configuredHost === 'string' && (configuredHost.includes('dev-api-') || configuredHost.includes('localhost') || configuredHost.includes('127.0.0.1'))) {
		return productionHost;
	}

	return configuredHost || productionHost;
};

export const shipmentHost = resolveProductionBrowserHost(config.config.api_shipments.merchant.shipmentHost, PRODUCTION_SHIPMENTS_HOST);
export const quoteHost = shipmentHost;
const resolveHostedShipmentHost = () => {
	if (process.env.REACT_APP_ENV_MODE === 'local-debug') {
		return process.env.REACT_APP_LOCAL_DEBUG_HOSTED_STAGE === 'development'
			? DEVELOPMENT_SHIPMENTS_HOST
			: PRODUCTION_SHIPMENTS_HOST;
	}

	return getHostedDashboardServiceHost({
		developmentHost: DEVELOPMENT_SHIPMENTS_HOST,
		productionHost: PRODUCTION_SHIPMENTS_HOST
	});
};

export const hostedShipmentHost = resolveHostedShipmentHost();
// export const shipmentHost = "http://192.168.1.48:8000"

export const hasuraHost = config.config.api_shipments.merchant.hasuraHost;
// export const hasuraHost = "http://192.168.1.48:8000"

export const getShipmentQuote = quoteHost + '/shipments/direct/quote';
export const getShipmentQuoteWithRate = quoteHost + '/shipments/direct/quote_with_rate';
export const supplyWarmUrl = quoteHost + '/shipments/direct/supply-warm';

export const toHostedShipmentUrl = url => {
	if (typeof url !== 'string') {
		return url;
	}

	if (!isLocalLikeHost(shipmentHost)) {
		return url;
	}

	return url.startsWith(shipmentHost) ? `${hostedShipmentHost}${url.slice(shipmentHost.length)}` : url;
};

export const createShipment = shipmentHost + '/shipments/direct/create';
export const createShipmentWithRate = shipmentHost + '/shipments/direct/create_with_rate';
export const createLTLShipment = shipmentHost + '/shipments/direct/create_with_ltl';
export const createScheduledShipment = createShipment + '/schedule';
export const createScheduledShipmentWithRate = createShipmentWithRate + '/schedule';
export const createSavedShipment = createShipment + '/save';
export const createSavedShipmentWithRate = createShipmentWithRate + '/save';
export const updateSavedShipmentWithRate = shipmentId => `${shipmentHost}/shipments/direct/saved/${shipmentId}/update`;
// Dispatch edit of an ACTIVE shipment (ready/merging/scheduled/delivering). Re-quotes and
// charges/refunds the price difference server-side, then refreshes the route for the driver.
export const updateActiveShipmentWithRate = shipmentId => `${shipmentHost}/shipments/direct/${shipmentId}/active/update`;
export const updateActiveRoutedShipment = shipmentId => `${shipmentHost}/shipments/direct/routed/${shipmentId}/active/update`;
export const updateActiveMultidropShipment = shipmentId => `${shipmentHost}/shipments/direct/multidrop/${shipmentId}/active/update`;
export const checkoutSavedShipment = shipmentId => toHostedShipmentUrl(`${shipmentHost}/shipments/direct/${shipmentId}/checkout`);

export const createRoutedShipment = shipmentHost + '/shipments/direct/routed/create';
export const createRoutedShipmentWithRate = shipmentHost + '/shipments/direct/routed/create_with_rate';
export const createRoutedScheduledShipment = createRoutedShipment + '/schedule';
export const createRoutedScheduledShipmentWithRate = createRoutedShipmentWithRate + '/schedule';
export const createRoutedSavedShipment = createRoutedShipment + '/save';

export const createMultidropShipment = shipmentHost + '/shipments/direct/multidrop/create';
export const createMultidropShipmentWithRate = shipmentHost + '/shipments/direct/multidrop/create_with_rate';
export const createMultidropScheduledShipment = createMultidropShipment + '/schedule';
export const createMultidropScheduledShipmentWithRate = createMultidropShipmentWithRate + '/schedule';
export const createMultidropSavedShipment = createMultidropShipment + '/save';

export const readyItem = shipmentHost + '/shipments/'; // + {shipment_id}/orders/{order_id}/items/{item_id}/ready
export const declineItem = shipmentHost + '/shipments/'; // + {shipment_id}/orders/{order_id}/items/{item_id}/decline
export const ReadyOrder = shipmentHost + '/shipments/'; // + {shipment_id}/orders/{{order_id}}/ready

// Pre-pay invoice check endpoint
export const advanceIfPaid = shipmentHost + '/shipments/'; // + {shipment_id}/invoice/advance-if-paid

// Route optimization endpoint
export const optimizeRoute = shipmentHost + '/shipments/routes/optimize';
export const preferredDrivers = shipmentHost + '/dispatch/preferred-drivers';
const merchantDashboardShipmentsHost = isLocalLikeHost(shipmentHost) ? hostedShipmentHost : shipmentHost;
export const merchantDashboardShipments = merchantDashboardShipmentsHost + '/shipments/merchant-dashboard';
export const merchantVolumeStats = merchantDashboardShipmentsHost + '/shipments/merchant-volume-stats';
export const pendingCustomerDriverReviews = merchantDashboardShipmentsHost + '/shipments/customer-driver-reviews/pending';
export const customerDriverReviewStats = merchantDashboardShipmentsHost + '/shipments/customer-driver-reviews/stats';
export const customerDriverReviewByShipment = shipmentId => `${merchantDashboardShipmentsHost}/shipments/${shipmentId}/customer-driver-review`;
export const submitCustomerDriverReview = shipmentId => `${merchantDashboardShipmentsHost}/shipments/${shipmentId}/customer-driver-review`;
